import React from 'react';
import { FINISH_STEP, GO_BACK_TO_STEP, } from '../../storage/TutorialReducer';
import { withRouter } from 'react-router-dom';

class TutorialStep3 extends React.Component {
  componentDidMount () {
    if (this.props.location.pathname !== '/') {
      this.props.history.push('/');
    }
  }

  goNext () {
    Storage.dispatch({type: FINISH_STEP, payload: 3});
  }

  goBack () {
    Storage.dispatch({type: GO_BACK_TO_STEP, payload: 2});
  }

  render () {
    return (
      <div className="c-tutorial-element">
        <h2 className="c-tutorial-element__subtitle">
          So what can you do here?
        </h2>
        <p>
          On the left side you have navigation where you can change to all the screens you need. Just above the
          navigation menu you have you current wallet address, along with current ASC and ETH balance.<br/>
          Home page is the first screen you see. Here is your general information inside the AsyncCoin Dapp. If you want
          free tokens to start this all off, you can subscribe to our newsletter for free 50 ASC.<br/>
          Below that is just a list of your latest transactions and Coin creations.
        </p>

        <div className="c-tutorial-element__button-container">
          <button onClick={this.goBack}>Back</button>
          <button onClick={this.goNext}>Next</button>
        </div>
      </div>
    );
  }
}

export default withRouter(TutorialStep3);


// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep3.js